// Calendly session types Otto offers, mirrored here so Otto can tag a
// client with whichever Calendly product they booked. Values are short
// machine slugs; labels match the Calendly event titles. Keep this in
// sync with https://calendly.com/thiel-fitfusionanalytics.
export const SESSION_PACKAGES = [
  { value: "none",                       label: "None" },
  { value: "info_call",                  label: "Free 15-Minute Info Call" },
  { value: "upper_lower_session",        label: "Upper OR Lower Body Performance Session" },
  { value: "upper_lower_program_4",      label: "Upper OR Lower Body Performance Program (4 Sessions)" },
  { value: "full_body_session",          label: "Full Body Performance Session" },
  { value: "full_body_program_4",        label: "Full Body Performance Program (4 Sessions)" },
  { value: "lumbar_assessment",          label: "Athletic Lumbar Performance Assessment" },
  { value: "performance_analysis",       label: "Performance Analysis Session" },
  { value: "return_to_performance",      label: "Return to Performance Session" },
];

// Quick lookup helper for displaying the friendly label.
export const SESSION_PACKAGE_LABELS = SESSION_PACKAGES.reduce((acc, p) => {
  acc[p.value] = p.label;
  return acc;
}, {});

export function sessionPackageLabel(value) {
  return SESSION_PACKAGE_LABELS[value] || value || "—";
}
